module.exports = __webpack_public_path__ + "img/Marketing.2a98c62d.svg";